export default "__VITE_ASSET__61n1EPRl__"